var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"70%"},scopedSlots:_vm._u([{key:"default",fn:function({ isActive }){return [_c('v-card',[_c('v-card-title',[((_vm.data.assigned_to == '-' && _vm.data.sampling == '-') || (_vm.data.assigned_to == null && _vm.data.sampling == null))?_c('span',[_vm._v(" Assign ")]):_c('span',[_vm._v("Edit ")]),_vm._v("  Data Penugasan Monitoring "+_vm._s(2)+" Tahunan ")]),_c('v-card-text',{staticClass:"ff-email-wrapper"},[_c('ValidationObserver',{ref:"firstForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[(_vm.data)?_c('v-row',{staticClass:"assign-ff-wrapper"},[_c('v-col',{attrs:{"lg":"12"}},[_c('v-row',{staticClass:"mx-3 bg-grey"},[_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                      label: 'Metode Sampling',
                      type: 'select',
                      validation: ['required'],
                      option: {
                        default_label: 'Sampling',
                        default_options: [
                          {
                            label: 'Tetap',
                            code: 'Tetap',
                          },
                          {
                            label: 'Random',
                            code: 'Random',
                          }
                        ],
                        list_pointer: {
                          label: 'label',
                          code: 'code',
                          display: ['label'],
                        },
                      },
                    }},model:{value:(_vm.sampling),callback:function ($$v) {_vm.sampling=$$v},expression:"sampling"}})],1),_c('v-col',{attrs:{"lg":"5"}},[_c('geko-input',{attrs:{"item":{
                      type: 'select',
                      label: 'Field Facilitator',
                      validation: ['required'],
                      api: 'GetFFNow',
                      option: {
                        getterKey: 'data.result',
                        list_pointer: {
                          code: 'ff_no',
                          label: 'name',
                          display: ['name', 'ff_no'],
                        },
                      },
                    }},model:{value:(_vm.assigned_to),callback:function ($$v) {_vm.assigned_to=$$v},expression:"assigned_to"}})],1)],1)],1)],1):_vm._e(),_c('v-row',[_c('v-col',{staticClass:"d-flex flex-row justify-content-center",attrs:{"lg":"12"}},[_c('v-btn',{staticClass:"d-flex flex-row align-items-center",attrs:{"variant":"warning","type":"submit"}},[_c('v-icon',[_vm._v("mdi-pencil-outline")]),_c('span',[_vm._v("Assign!")])],1)],1)],1),_c('v-row')],1)]}}],null,true)})],1)],1)]}}]),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }